import { ca } from '@cian/analytics';
import { ECode } from '../../../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';

export function trackNewStatusClick(newStatus: ECode) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_status',
    label: newStatus,
    category: 'MyHome',
  });
}

export function trackStatusLabelClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    label: 'Status',
    category: 'MyHome',
  });
}
